import { render, staticRenderFns } from "./FirmPanel.vue?vue&type=template&id=1978a164"
import script from "./FirmPanel.vue?vue&type=script&lang=js"
export * from "./FirmPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports